import React, { useState, useMemo } from 'react';

import Modal from '../../Modal';
import Select from '../../Form/Select';
import { participantAgeRange } from '../../../constants/tourInterestForm';

const AddMemberModal = ({ open, onClose, addMember, additionalMembersCount }) => {
  const [ageRange, setAgeRange] = useState();
  const [formValidationErrors, setFormValidationErrors] = useState({});

  const handleSubmit = (event) => {
    event.preventDefault();
    const { name, ageRange } = event.target;

    // set form validation errors
    const errors = {};
    if (!name?.value) errors.name = 'Name is required';
    if (!ageRange?.value) errors.ageRange = 'Age range is required';
    setFormValidationErrors(errors);
    if (Object.keys(errors).length > 0) return;

    addMember({ name: name.value, ageRange: ageRange.value });
    event.target.reset();
    setAgeRange(null);
    onClose();
  };

  const index = useMemo(
    // prevent index from changing when modal is open
    () => (open ? additionalMembersCount + 1 : additionalMembersCount),
    [open]
  );

  return (
    <Modal open={open} onClose={onClose} sx={{ maxWidth: '600px' }}>
      <div className="card-additional-member">
        <h4>Additional Member {index}</h4>
        <form onSubmit={handleSubmit}>
          <div className="form-element">
            <label>Full Name</label>
            <input type="text" name="name" className="w-full" />
            <label className="form-error">{formValidationErrors.name}</label>
          </div>

          <div className="form-element">
            <label className="label-margin">Age Range</label>
            <Select
              name="ageRange"
              value={ageRange}
              onChange={setAgeRange}
              button={<div className="w-full text-left">{ageRange}</div>}
              className="w-full"
              buttonClass="w-full"
            >
              {participantAgeRange.map((ageRange) => (
                <Select.Option value={ageRange} key={ageRange}>
                  {ageRange}
                </Select.Option>
              ))}
            </Select>
            <label className="form-error">{formValidationErrors.ageRange}</label>
          </div>

          <div className="form-element submit">
            <input type="submit" value="Add" className="btn btn-md btn-primary-ii btn-submit" />
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddMemberModal;
